var prism = /** @class */ (function () {
    function prism() {
    }
    prism.STORE_MODULE_NAME = 'prism';
    return prism;
}());
export { prism };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/prism/lib/prism.cls.ts
// module id = bD82
// module chunks = 75